import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { defaultChildRoute } from "./legacy-redirects";

/**
 * Sub-pages share one layout route because the CSAT save writes the whole
 * settings object; splitting the form would let one page clobber another.
 */
export const csatRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "CSAT",
      permission: SettingsPermissions.SET_SUPPORT_SETTINGS,
    },
    async lazy() {
      const { CsatSettingsLayout } =
        await import("../../../setting/customer-satisfaction/csat-settings-shell");
      return { Component: CsatSettingsLayout };
    },
    children: [
      defaultChildRoute("general"),
      {
        path: "general",
        handle: { breadcrumb: "General" },
        async lazy() {
          const { CsatGeneralPage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatGeneralPage };
        },
      },
      {
        path: "template",
        handle: { breadcrumb: "Templates" },
        async lazy() {
          const { CsatTemplatePage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatTemplatePage };
        },
      },
      {
        path: "ab-tests",
        handle: { breadcrumb: "A/B test" },
        async lazy() {
          const { CsatAbTestsPage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatAbTestsPage };
        },
      },
    ],
  },
];
